import { SproutOutlineIcon } from './SproutOutlineIcon';

/**
 * author: Michael Irigoyen
 * id DDE9D3A4-FF81-4182-8FEE-3A0DD30F88F8
 * name sprout-outline
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sprout-outline.svg
 * tags
 * - Agriculture 
 * - Nature 
 */
export const EnvironmentOutlineIcon = SproutOutlineIcon;
export default EnvironmentOutlineIcon